module.exports = __webpack_public_path__ + "pic/16.b89a8463.png";